import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import ProductSpotlight from "@/components/ProductSpotlight";
import Formula from "@/components/Formula";
import Manifesto from "@/components/Manifesto";
import BMICalculator from "@/components/BMICalculator";
import BuildYourBox from "@/components/BuildYourBox";
import Reviews from "@/components/Reviews";
import FAQ from "@/components/FAQ";
import { useProducts } from "@/context/ProductsContext";

const Home = () => {
  const { products } = useProducts();

  return (
    <>
      <Hero />
      <Marquee />
      <div id="collection">
        {products.map((product, index) => (
          <ProductSpotlight key={product.slug} product={product} index={index} />
        ))}
      </div>
      <Formula />
      <BMICalculator />
      <BuildYourBox />
      <Manifesto />
      <Reviews />
      <FAQ />
    </>
  );
};

export default Home;
